import { Dashboard, OffPlan } from '@/components';

export const OffPlanPage = () => (
  <Dashboard isSearch openLogIn>
    <OffPlan />
  </Dashboard>
);
